<template>
  <div class="container grid-lg mb-2 p-0" aria-labelledby="header-title">
    <Header title="Branch"></Header>

    <header id="subheader" class="navbar">
      <section class="navbar-section">
        <nav aria-label="Breadcrumb">
          <ul class="breadcrumb px-2">
            <li class="breadcrumb-item">
              <router-link to="/">Case</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/branch">Branches</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">{{ ord }}</li>
          </ul>
        </nav>
      </section>
      <section class="navbar-section">
        <HelpButton section="branches" />
        <button v-on:click="deleteBranch" type="button" class="btn btn-sm">
          Delete
        </button>
      </section>
    </header>

    <div class="columns px-2">
      <div class="column col-6 col-sm-12">
        <BranchForm v-bind:ord="ord"></BranchForm>
      </div>

      <div class="column col-6 col-sm-12">
        <table v-if="pf_br" class="table m-2">
          <caption>
            Power Flow Results
          </caption>
          <tr>
            <td>Active Power From (P<sub>f</sub>)</td>
            <td class="text-right">{{ formatNumeral(pf_br[PF], 3) }} MW</td>
          </tr>
          <tr>
            <td>Reactive Power From (Q<sub>f</sub>)</td>
            <td class="text-right">{{ formatNumeral(pf_br[QF], 3) }} MVAr</td>
          </tr>
          <tr>
            <td>Active Power To (P<sub>t</sub>)</td>
            <td class="text-right">{{ formatNumeral(pf_br[PT], 3) }} MW</td>
          </tr>
          <tr>
            <td>Reactive Power To (Q<sub>t</sub>)</td>
            <td class="text-right">{{ formatNumeral(pf_br[QT], 3) }} MVAr</td>
          </tr>
        </table>

        <table v-if="opf_br" class="table m-2">
          <caption>
            OPF Results
          </caption>
          <tr>
            <td>Active Power From (P<sub>f</sub>)</td>
            <td class="text-right">{{ formatNumeral(opf_br[PF], 3) }} MW</td>
          </tr>
          <tr>
            <td>Reactive Power From (Q<sub>f</sub>)</td>
            <td class="text-right">{{ formatNumeral(opf_br[QF], 3) }} MVAr</td>
          </tr>
          <tr>
            <td>Active Power To (P<sub>t</sub>)</td>
            <td class="text-right">{{ formatNumeral(opf_br[PT], 3) }} MW</td>
          </tr>
          <tr>
            <td>Reactive Power To (Q<sub>t</sub>)</td>
            <td class="text-right">{{ formatNumeral(opf_br[QT], 3) }} MVAr</td>
          </tr>
        </table>

        <table v-if="opf_br" class="table m-2">
          <tr>
            <td>MVA Limit From Mult (μ<sub>Sf</sub>)</td>
            <td class="text-right">
              {{ formatNumeral(opf_br[MU_SF], 2) }} $/MVA
            </td>
          </tr>
          <tr>
            <td>MVA Limit To Mult (μ<sub>St</sub>)</td>
            <td class="text-right">
              {{ formatNumeral(opf_br[MU_ST], 2) }} $/MVA
            </td>
          </tr>
          <tr>
            <td>Upper Angle Diff. Limit Mult (μ<sub>AngMax</sub>)</td>
            <td class="text-right">
              {{ formatNumeral(opf_br[MU_ANGMAX], 2) }} $/&deg;
            </td>
          </tr>
          <tr>
            <td>Lower Angle Diff. Limit Mult (μ<sub>AngMin</sub>)</td>
            <td class="text-right">
              {{ formatNumeral(opf_br[MU_ANGMIN], 2) }} $/&deg;
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import numeral from "numeral-es6";

import Header from "../components/Header";
import BranchForm from "../components/branch/BranchForm";
import HelpButton from "../components/HelpButton";
import MPCStore from "../stores/MPCStore";
import PFStore from "../stores/PFStore";
import OPFStore from "../stores/OPFStore";

import {
  PF,
  QF,
  PT,
  QT,
  MU_SF,
  MU_ST,
  MU_ANGMAX,
  MU_ANGMIN
} from "../stores/idx";

export default {
  name: "Branch",
  components: {
    Header,
    HelpButton,
    BranchForm
  },
  props: ["ord"],
  data() {
    return {
      pf_br: PFStore.methods.getBranch(+this.ord - 1),
      opf_br: OPFStore.methods.getBranch(+this.ord - 1),
      PFStore: PFStore.data,
      OPFStore: OPFStore.data,
      PF: PF,
      QF: QF,
      PT: PT,
      QT: QT,
      MU_SF: MU_SF,
      MU_ST: MU_ST,
      MU_ANGMAX: MU_ANGMAX,
      MU_ANGMIN: MU_ANGMIN
    };
  },
  methods: {
    formatNumeral: (v, n) => numeral(v).format("0.[" + "0".repeat(n) + "]"),
    deleteBranch() {
      if (confirm("Are you sure you want to delete this branch?")) {
        MPCStore.methods.deleteBranch(this.ord - 1);
        this.$router.push("/branch");
      }
    }
  },
  watch: {
    PFStore: {
      handler() {
        this.pf_br = PFStore.methods.getBranch(+this.ord - 1);
      },
      deep: true
    },
    OPFStore: {
      handler() {
        this.opf_br = OPFStore.methods.getBranch(+this.ord - 1);
      },
      deep: true
    }
  }
};
</script>
